import { Action, configureStore, getDefaultMiddleware, ThunkAction } from '@reduxjs/toolkit';
import { MOCK } from 'App';
import { dettaglioCampagnaReducer } from 'pages/admin/campagne/dettaglio-campagna/_redux/reducer';
import { homeCampagnaReducer } from 'pages/admin/campagne/home-campagna/_redux/reducer';
import { nuovaCampagnaReducer } from 'pages/admin/campagne/nuova-campagna/_redux/reducer';
import { homeDashboardReducer } from 'pages/admin/dashboard/home-dashboard/_redux/reducer';
import { logCertificazioniInfocenterReducer } from 'pages/admin/log-certificazioni-infocenter/_redux/reducer';
import { logTracciatoInfocenterReducer } from 'pages/admin/log-tracciato-infocenter/_redux/reducer';
import { dettaglioCertificazioneReducer } from 'pages/admin/ricerca/dettaglio-certificazione/_redux/reducer';
import { dettaglioClienteReducer } from 'pages/admin/ricerca/dettaglio-cliente/_redux/reducer';
import { ricercaAnagrafeReducer } from 'pages/admin/ricerca/ricerca-anagrafe/_redux/reducer';
import { ricercaClientiReducer } from 'pages/admin/ricerca/ricerca-clienti/_redux/reducer';
import { clienteReducer } from 'pages/cliente/_redux/reducer';
import authenticationReducer from '../pages/admin/_redux/reducer';
import { generalReducer } from './reducer';
export interface ExtraArgument {
  mock: boolean
}

export const store = configureStore({
  reducer: {
    general: generalReducer,
    ricercaClienti: ricercaClientiReducer,
    ricercaAnagrafe: ricercaAnagrafeReducer,
    dettaglioCliente: dettaglioClienteReducer,
    authentication: authenticationReducer,
    dettaglioCertificazione: dettaglioCertificazioneReducer,
    homeDashboard: homeDashboardReducer,
    homeCampagna: homeCampagnaReducer,
    dettaglioCampagna: dettaglioCampagnaReducer,
    nuovaCampagna: nuovaCampagnaReducer,
    logCertificazioniInfocenter: logCertificazioniInfocenterReducer,
    logTracciatoInfocenter: logTracciatoInfocenterReducer,
    cliente: clienteReducer,

  },
  middleware: getDefaultMiddleware({
    serializableCheck: false,
    thunk: {
      extraArgument: {
        mock: MOCK
      }
    }
  })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export interface ThunkApiConfig {
  state: RootState,
  extra: ExtraArgument
}
